import { connect } from 'react-redux';

import { GET_LIST_ROOM_OF_PLACE, GET_PLACE_PRICE_TYPES } from 'store/place/actionTypes';
import {
  CLEAR_PROMOTION_DETAIL, CREATE_PROMOTION, EDIT_PROMOTION, GET_PROMOTION_DETAIL,
} from 'store/promotion/actionTypes';

import CreateEarlyPromotion from './CreateEarlyPromotion';

const mapStateToProps = (state) => ({
  isLoadingCreatePromotion: state.Promotion.isLoadingCreatePromotion,

  promotionDetail: state.Promotion.promotionDetail,
  roomOfPlaceList: state.Place.roomOfPlaceList,
  placePriceTypes: state.Place.placePriceTypes,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetListRoomsOfPlace: (payload) => dispatch({
    type: GET_LIST_ROOM_OF_PLACE,
    payload,
  }),

  actionGetPlacePriceTypes: (payload) => {
    dispatch({
      type: GET_PLACE_PRICE_TYPES,
      payload,
    });
  },

  actionPostPromotion: (payload) => {
    dispatch({
      type: CREATE_PROMOTION,
      payload,
    });
  },

  actionGetPromotionDetail: (payload) => {
    dispatch({
      type: GET_PROMOTION_DETAIL,
      payload,
    });
  },

  actionEditPromotion: (payload) => {
    dispatch({
      type: EDIT_PROMOTION,
      payload,
    });
  },

  actionClearDataPromotionDetail: (payload) => {
    dispatch({
      type: CLEAR_PROMOTION_DETAIL,
      payload,
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateEarlyPromotion);
